module.exports = "https://static.wmbcdn.com/uniweb/images/5b094eed0b346307c67da57e90e48239.svg";